import { FC } from 'react';
import './style.scss';
import InputButton from '../../../input-button/input-button.component';

type InteractiveButtonComponentProps = {
  loading: boolean;
  label: string;
  type: 'button' | 'submit' | 'reset' | undefined;
  allRequiredInputsHaveValue: boolean;
  onFormAttemptSubmit: () => void;
};

const InteractiveButtonComponent: FC<
  InteractiveButtonComponentProps
> = props => {
  const {
    loading,
    label,
    type,
    allRequiredInputsHaveValue,
    onFormAttemptSubmit,
  } = props;

  return (
    <InputButton
      type={type}
      value={label}
      dataDisabled={!allRequiredInputsHaveValue}
      loading={loading}
      onClick={onFormAttemptSubmit}
    />
  );
};

export default InteractiveButtonComponent;
